const formatPhoneNumber = (value: string) => {
  if (!value) return value;

  // Remove all non-numeric characters
  const phoneNumber = value.replace(/\D/g, "");

  // Check if it's a mobile number (11 digits) or landline (10 digits)
  if (phoneNumber.length <= 10) {
    // Format as landline: (XX) XXXX-XXXX
    return phoneNumber
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .substr(0, 14);
  } else {
    // Format as mobile: (XX) XXXXX-XXXX
    return phoneNumber
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .substr(0, 15);
  }
};

const formatCPF = (value: string) => {
  if (!value) return value;

  // Remove all non-numeric characters
  const cpf = value.replace(/\D/g, "");

  // Format as CPF: XXX.XXX.XXX-XX
  return cpf
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    .substring(0, 14);
};

export { formatPhoneNumber, formatCPF };
